// extracted by mini-css-extract-plugin
export default {"row":"StudentFormRow_row__FiJd3"};